import { computed, Directive, input } from '@angular/core';
import { hlm } from '@spartan-ng/helm/utils';
import { ClassValue } from 'clsx';

@Directive({
  selector: 'span[cardItemTitle]',
  host: {
    'data-slot': 'item-title',
    '[class]': '_computedClass()',
  },
})
export class CardItemTitle {
  public readonly userClass = input<ClassValue>('', { alias: 'class' });
  protected readonly _computedClass = computed(() => hlm('pl-xs component-medium-medium flex-1', this.userClass()));
}
